









































import { mapGetters } from 'vuex';

import {
  getAutoclickerUrlConfiguration,
  updateAutoclickerUrlConfiguration
} from '@/api/CopyStake/Settings';
import {
  TCopyStakeSettingsAutoclickerUrlResponse,
  TCopyStakeSettingsAutoclickerUrlPayload,
  ValidationRules
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import * as vr from '@/helpers/validation';
import { cloneDeep, isEqual } from 'lodash';
import type { AxiosError } from 'axios';

export default {
  name: 'CopyStakeSettingsAutoclickerUrl',
  data(): any {
    return {
      autoclickerUrlSavedData: {
        operatorUrl: ''
      },
      autoclickerUrl: {
        operatorUrl: ''
      },

      isLoading: false,
      formValid: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    autoclickerUrlChanged(): boolean {
      return !isEqual(this.autoclickerUrl, this.autoclickerUrlSavedData);
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.autoclickerUrlChanged;
    },

    rules(): ValidationRules {
      return {
        operatorUrlRules: [(v) => v === '' || v === null || vr.url(v)]
      };
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    parseSettingsData(data: TCopyStakeSettingsAutoclickerUrlResponse): void {
      const parsedData = {
        operatorUrl: String(data.operatorUrl ?? '')
      };

      this.autoclickerUrlSavedData = cloneDeep(parsedData);
      this.autoclickerUrl = cloneDeep(parsedData);
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getAutoclickerUrlConfiguration()
        .then((data: TCopyStakeSettingsAutoclickerUrlResponse) => {
          this.parseSettingsData(data);
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      const isFormValid = await this.$refs.form.validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const payload: TCopyStakeSettingsAutoclickerUrlPayload =
        this.autoclickerUrl;

      await updateAutoclickerUrlConfiguration(payload)
        .then((data: TCopyStakeSettingsAutoclickerUrlResponse) => {
          this.parseSettingsData(data);

          this.$toast.success('Autoclicker URL was successfully updated!');
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
